import React from 'react';
import Cursos from './components/Cursos';

function App() {
  return (
    <div className="curso">
        <Cursos/>
    </div>
  );
}

export default App;
